export const IMG = "https://static.prod-images.emergentagent.com/jobs/904b13c3-dacf-4078-a111-b1121cfb159b/images";

export const IMAGES = {
    paperPulpCat: `${IMG}/28a20ac5cfe41406076ea10b408732b74503528d0c305310df976d487baedf58.jpeg`,
    paperPencilCup: `${IMG}/ed256af8b60e6ab5754dee1eb9270ac122fcab783d9e2d14ecca1911e447d68c.jpeg`,
    paperBasket: `${IMG}/73a99f409b6116139c1aac82982f3271816fe6822bedd7ea49eb44e513ce0e9d.jpeg`,
    paperVase: `${IMG}/28dbed0ba6d15b8b2d19c2b8d35be208de96ba6954a115d7e752a67a222c33ee.jpeg`,
    paperKeychain: `${IMG}/acbea3fd2e1380c98654d785f0b48d26fc94a5e942ef08e69ca6d06685ae4110.jpeg`,
    paperPhoneStand: `${IMG}/af8d4d0313570699dc895fe0f1e7622017e0026a99a857b9d3e82cbc71183644.jpeg`,
    workshop: `${IMG}/ebfd53eb3fd5cf2f95b507ee9082cc1feb9ee2c560f1b816fd06095003fe04f5.jpeg`,
};

export const CATEGORIES = ["Semua Karya", "Tempat Pensil", "Keranjang", "Mainan Cat", "Dekorasi", "Lainnya"];
